// An error as text for a log line: its message, and for an HTTP error the request's url and the response status,
// then its stack. An HTTP error object carries its whole request and config, which must never be logged.
export const describe_error = (error)=>{
	let description = String(error && error.message ? error.message : error);
	if(error && error.config && error.config.url){
		description += ' (' + error.config.url;
		if(error.response){
			description += ', status ' + error.response.status;
		}

		description += ')';
	}

	if(error && error.stack){
		description += '\n' + error.stack;
	}

	return description;
};
